import {inject, Injectable} from '@angular/core'
import {MatIconRegistry} from '@angular/material/icon'
import {DomSanitizer} from '@angular/platform-browser'

@Injectable({
  providedIn: 'root',
})
export class Bootstrap {

  private readonly iconRegistry = inject(MatIconRegistry)
  private readonly sanitizer = inject(DomSanitizer)

  public bootstrap() {
    this.iconRegistry.addSvgIcon('icon', this.sanitizer.bypassSecurityTrustResourceUrl('icon.svg'))
  }
}
